import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { BookingBase } from '../booking.base';

@Component({
    selector: 'booking-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent extends BookingBase {
  
  constructor(protected deviceService: DeviceDetectorService) {
    super(deviceService)
  }

}
